const aspect = 1.2;
const cameraZ = 300;
const canvasWidth = () => window.innerWidth / 1.8;
const canvasHeight = () => canvasWidth() / aspect;

function getContainerSize(container) {
  if (!container || !(container instanceof Element)) {
    const w = Math.max(320, window.innerWidth / 1.8);
    const h = Math.max(240, w / aspect);
    return { width: Math.floor(w), height: Math.floor(h), aspect: w / h };
  }
  const rect = container.getBoundingClientRect();
  let w = rect.width || container.clientWidth;
  let h = rect.height || container.clientHeight;
  if (w < 2) {
    const p = container.parentElement;
    w = p ? p.clientWidth : 320;
  }
  if (h < 2) h = 400;
  w = Math.max(2, w);
  h = Math.max(2, h);
  return { width: Math.floor(w), height: Math.floor(h), aspect: w / h };
}

export { aspect, cameraZ, canvasWidth, canvasHeight, getContainerSize };
